import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import { RainTickerType } from 'features/Location/@types/HubWeather'

const { Get, Put } = axiosInstanceApiGateway

export type GetRainTickersRequestType = {
  params: { search: string; status: number }
}

export type GetRainTickersResponseType = {
  locations: RainTickerType[]
  updated_at: string
}

export const getRainTickers = ({ params }: GetRainTickersRequestType) =>
  Get<GetRainTickersResponseType>({
    url: `/location/internal/v1/rain-ticker`,
    params,
  })

export type PutRainTickerRequestType = {
  id: string
  data: {
    status: boolean
  }
}

export type PutRainTickerResponseType = {
  message: string
}

export const putRainTicker = ({ id, data }: PutRainTickerRequestType) =>
  Put<PutRainTickerResponseType>({
    url: `/location/internal/v1/rain-ticker/${id}`,
    data,
  })
export type PutRainTickersRequestType = {
  data: { ids: string[]; status: boolean }
}

export const putRainTickers = ({ data }: PutRainTickersRequestType) =>
  Put<PutRainTickerResponseType>({
    url: `/location/internal/v1/rain-ticker/bulk/update-status`,
    data,
  })
